import React from "react"
import { useTranslation } from "react-i18next"
import { twMerge } from "tailwind-merge"
import { useAppDispatch, useAppSelector } from "store/hooks"
import { statusMessageSelector } from "features/bikeFleet/slice/bikeFleetSelector"
import { resetUpdatedBikeStatus } from "features/bikeFleet/slice/bikeFleetSlice"
import { SUCCESS } from "features/bikeFleet/constant"
import { CrossIcon } from "components/Elements/Icons"
import CheckCircle from "components/Elements/Icons/CheckCircle"
import NotAllowedIcon from "components/Elements/Icons/NotAllowed"

export const MessageStatusBikeFleet: React.FC = () => {
	const messageStatus = useAppSelector(statusMessageSelector)
	const dispatch = useAppDispatch()

	const { t } = useTranslation()

	const onClose = () => {
		dispatch(resetUpdatedBikeStatus())
	}

	if (messageStatus) {
		return (
			<div
				className={twMerge(
					" p-4 mt-4 flex shadow-md border-slate-100/50 items-center border rounded-lg"
				)}
				role="alert"
			>
				<div className="flex-1 text-slate-900 flex gap-4 items-center">
					<React.Fragment>
						{messageStatus.type === SUCCESS ? (
							<CheckCircle width={25} height={25} />
						) : (
							<NotAllowedIcon width={25} height={25} color="#ff7761" />
						)}{" "}
					</React.Fragment>
					<div>{t(`bikeFleet.actions.${messageStatus.message}`, { ns: "bike" })}</div>
				</div>
				<button onClick={onClose}>
					<CrossIcon size={15} className={""} />
				</button>
			</div>
		)
	}
	return null
}
